import React, { Component } from 'react'
import { Form, Input, Button } from 'antd'
import { connect } from 'dva'
import InputMask from 'react-input-mask';
const _ = require('underscore')

const FormItem = Form.Item;

class ProfileResume extends Component {

    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    constructor (props) {
        super(props);

        this.state = {};
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        const user = this.props.app.user;
        this.props.form.setFieldsValue(user);
    }


    /**
    * Validator: Checa el correcto formato del teléfono
    */
    checkPhone (rule, value, callback) {
        if (value && value.replace(/[^\d.]/g, '').length < 10) {
            callback('Por favor, ingrese un número de teléfono válido!');
        } else {
            callback();
        }
    }


	/**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            if (values.phone)
                values.phone = values.phone.replace(/[^\d.]/g, '');

            if (values.mobile_phone)
                values.mobile_phone = values.mobile_phone.replace(/[^\d.]/g, '');
           
            _.extend(this.props.app.user, values);
            this.props.dispatch({type: 'user/update', payload: this.props.app.user})
            localStorage.setItem('currentUser', JSON.stringify(this.props.app.user));
        })
    }


  	/**
    * Render del componente
    */
    render () {
	    return (
            <div>
                <div className="col-md-12">
                    <div className="col-md-4">
                        <FormItem label="Nombre completo" hasFeedback>
                            {this.props.form.getFieldDecorator('name', {
                                rules: [{
                                    required: true,
                                    message: 'Por favor, ingrese el nombre completo'
                                }]
                            })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                        </FormItem>
                    </div>

                    <div className="col-md-4">
                        <FormItem label="Correo electrónico" hasFeedback>
                            {this.props.form.getFieldDecorator('email', {
                                rules: [{
                                    type: 'email',
                                    required: true,
                                    message: 'Por favor, ingrese el correo electrónico del usuario'
                                }]
                            })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                        </FormItem>
                    </div>

                    <div className="col-md-4">
                        <FormItem label="Teléfono" hasFeedback>
                            {this.props.form.getFieldDecorator('phone', {
                                rules: [{
                                    required: false,
                                }, {
                                    validator: this.checkPhone.bind(this)
                                }]
                            })(<InputMask mask="(999) 999 9999" className="ant-input ant-input-lg" />)}
                        </FormItem>
                    </div>

                    <div className="col-md-4">
                        <FormItem label="Celular" hasFeedback>
                            {this.props.form.getFieldDecorator('mobile_phone', {
                                rules: [{
                                    required: false,
                                    message: 'Por favor, ingrese el teléfono celular del usuario'
                                }, {
                                    validator: this.checkPhone.bind(this)
                                }]
                            })(<InputMask mask="(999) 999 9999" className="ant-input ant-input-lg" />)}
                        </FormItem>
                    </div>
                </div>

                <div className="row text-center marginBottom30">
                    <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                        Actualizar información
                    </Button>
                </div>
            </div>
	    )
	}
}

export default connect(({currentInvoice, app}) => ({currentInvoice, app}))(Form.create()(ProfileResume))


// WEBPACK FOOTER //
// ./src/components/profile/profileResume.js